import { bindable, computedFrom } from 'aurelia-framework';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.main';

class ProductFeedsSettingsForm {
  @bindable loading = false;
  @bindable account = null;
  @bindable settings = null;
  @bindable onSave = () => {};
  @bindable onInvalidCode = () => {};
  @bindable onChanged = () => {};
  hasErrors = false;
  _lastChangedStatus = false;
  _settings = null;
  _editor = null;
  _result = false;
  _ignoreNextChange = false;
  _validating = false;
  /**
   * This is called when the container is unloaded. Inside it will reset the settings
   * to their original value.
   */
  detached() {
    this.settings = null;
    this._lastChangedStatus = false;
  }
  loadingChanged(currentValue, previousValue) {
    if (!this._editor && !currentValue && previousValue && this.account) {
      this._loadEditor();
    }
  }
  save() {
    this._detectEditorErrors();
    if (!this.hasErrors && this._validateJSON()) {
      this.onSave({
        settings: this._settings,
      });
    }
  }
  settingsChanged(previousValue) {
    if (previousValue === null) {
      this._ignoreNextChange = true;
    }
    if (this._editor) {
      this._settings = this.settings;
      this._editor.setValue(this._settings);
    }
  }
  @computedFrom('loading', 'hasChanged', 'hasErrors', '_validating')
  get disableSubmit() {
    return this.loading || this.hasErrors || !this.hasChanged || this._validating;
  }
  @computedFrom('settings', '_settings')
  get hasChanged() {
    return this.settings !== this._settings;
  }
  _detectEditorErrors() {
    this.hasErrors = (monaco.editor.getModelMarkers({}).length > 0);
  }
  _loadEditor() {
    this._settings = this.settings;
    setTimeout(() => {
      this._editor = monaco.editor.create(this.editor, {
        value: this._settings,
        language: 'json',
        scrollBeyondLastLine: false,
      });

      const oneSecond = 1000;
      this._editor.onDidChangeModelContent(() => {
        this._settings = this._editor.getValue();
        if (this._ignoreNextChange) {
          this._ignoreNextChange = false;
        } else if (this.hasChanged !== this._lastChangedStatus) {
          this._lastChangedStatus = this.hasChanged;
          this._validating = true;
          this.onChanged({
            hasChanged: this.hasChanged,
          });
        }
        setTimeout(() => {
          this._detectEditorErrors();
          this._validating = false;
        }, oneSecond);
      });
    }, 0);
  }
  _validateJSON() {
    let result = true;
    try {
      JSON.parse(this._settings);
    } catch (error) {
      this.onInvalidCode({
        message: error,
      });
      result = false;
    }

    return result;
  }
}

export { ProductFeedsSettingsForm };
